import { HEATMAP_OBSERVABLE_TOPICS } from '@Pages/Heatmap/constants';
import RXService from '@Services/RxService';
import { setOpenFiltersType } from './ResultsFiltersConstants';

export function addClassesToResultContainer(open) {
  const resultContainer = document.querySelector('#results-container');

  if (!resultContainer) {
    return;
  }

  if (open) {
    resultContainer.classList.remove('results-when-filters-close');
    resultContainer.classList.add('results-when-filters-open');

    return;
  }

  resultContainer.classList.remove('results-when-filters-open');
  resultContainer.classList.add('results-when-filters-close');
}

export function setOpenFiltersAction(isOpen) {
  return {
    type: setOpenFiltersType,
    payload: {
      isOpen,
    },
  };
}

export function setOpenFilters(isOpen) {
  return (dispatch) => {
    setTimeout(() => {
      RXService.next(HEATMAP_OBSERVABLE_TOPICS.resizeWindow);
    }, 0);

    addClassesToResultContainer(isOpen);

    dispatch(setOpenFiltersAction(isOpen));
  };
}
